var React = require('react');

function ExternalInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-21.71 -166)"},[React.createElement("rect",{"x":"24.49","y":"167","width":"3.127","height":"3.125","fill":"none","stroke":"currentColor","strokeWidth":".2646","key":0}),React.createElement("path",{"d":"m28.59 166-0.2981 1.763-0.7186-0.7466-0.7584-0.7584z","fill":"currentColor","key":1}),React.createElement("path",{"d":"m27.63 166.9c-0.07882 0.0788-0.8267 0.8262-0.8267 0.8262","fill":"none","stroke":"currentColor","strokeWidth":".2646","key":2})]));
}

ExternalInline.defaultProps = {"width":"26.02","height":"22.01","version":"1.1","viewBox":"0 0 6.883 5.823"};

module.exports = ExternalInline;

ExternalInline.default = ExternalInline;
